<template>
  <div>
    <div v-if="is_super_admin" class="my-table-style">
      <el-table
      :data="feedbackList"
      style="width: 100%;border-color:'#606266'"
      
      :default-sort = "{prop: 'date', order: 'descending'}"
      :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
      :cell-style="{color: '#666',fontSize:'14px'}"
      border
      >

      <el-table-column
          fixed
          align="center"
          prop="feedback_id"
          label="反馈问题ID"
          sortable
          >
          </el-table-column>

        <el-table-column
          fixed
          align="center"
          prop="feedback_img_list"
          label="反馈问题图片"
          sortable
          >
          <template slot-scope="scope">

            <el-image 
              v-for='url in scope.row.feedback_img_list' :key="url"
              style="width: 100px; height: 100px"
              :src="url" 
              :preview-src-list="scope.row.feedback_img_list">
            </el-image>
            
          </template>
          </el-table-column>

        <el-table-column
          fixed
          align="center"
          prop="feedback_content"
          label="反馈问题内容"
          sortable
          >
          </el-table-column>

          <el-table-column
          align="center"
          label="操作"
          >
          <template slot-scope="scope">
            <el-button round icon="el-icon-delete" type="danger" size="small" @click="deleteFeedback(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination
        @current-change="changeCurrent"
        :current-page="iCurrentPage"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="iMaxTotal"
        style="text-align:right; margin-top:15px"
      >
      </el-pagination>
      
    </div>

    <div v-else>
      <div style="text-align: center;">
        <div style="margin-top: 0px;">
          <img src="../assets/permission_denied.png">
          <div style="margin-top: 20px;">
            <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>

export default {
  name: "Home",
  data() {
    return {
      feedbackList: [],
      iCurrentPage: 1,
      iMaxTotal: 10,
      is_super_admin:false,
    };
  },
  
  mounted() {
    // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
    let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
    if (isSuperAdmin == "false") {
      this.is_super_admin = false
      return
    } else {
      this.is_super_admin = true
    }
    // 请求问题反馈的列表
    this.getFeedbackList()

  },

  methods: {
    // 请求问题反馈的列表
    async getFeedbackList() {
      let d_params = {
        'page': this.iCurrentPage,
        'page_size': 10,
      }

      const res = await this.$axios.get('/api/feedback/', {params: d_params});
      this.feedbackList = res.data.results;
      this.iMaxTotal = res.data.count;

      console.log(this.feedbackList)

    },

    // 分页事件
    changeCurrent(val){
      this.iCurrentPage = val;
      this.getFeedbackList();
    },

    // 删除操作
    async deleteFeedback(row){
      // console.log(index)

      var _this = this
        this.$confirm('此操作将永久删除该反馈问题', '删除反馈问题警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
        _this.$axios.delete('/api/feedback/' + row.feedback_id + '/').then(
            function(res){
              _this.$message({
                type: 'success',
                message: '删除成功!'
              });
              _this.getFeedbackList()
            }
          )
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    }

  },
    
};
</script>

<style lang="less" type="text/less">
.sortable-ghost {
  opacity: 0.4;
  background-color: #f30606;
}
</style>

